import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../utils/gtag";

/**
 * Sends a gtag page view on every client-side route change.
 *
 * The web app is a single page app, so the config call in public/index.html
 * only ever registers the entry page. Without this component Google Ads would
 * see one page view per visit no matter how many pages the visitor opens,
 * which breaks remarketing lists built on specific URLs.
 *
 * Renders nothing. Must be mounted inside <BrowserRouter>.
 */
export default function GtagRouteTracker(): null {
  const location = useLocation();
  // The initial page view is already sent by the base tag in index.html.
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const path = `${location.pathname}${location.search}`;
    // Let React commit the new page (and its document.title) before reporting.
    const id = window.setTimeout(() => trackPageView(path), 0);
    return () => window.clearTimeout(id);
  }, [location.pathname, location.search]);

  return null;
}
